"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.darkAlpha400 = exports.darkAlpha300 = exports.darkAlpha200 = exports.darkAlpha100 = exports.dangerBase = exports.danger900 = exports.danger800 = exports.danger700 = exports.danger600 = exports.danger500 = exports.danger50 = exports.danger400 = exports.danger300 = exports.danger200 = exports.danger100 = exports.brandYellow900 = exports.brandYellow800 = exports.brandYellow700 = exports.brandYellow600 = exports.brandYellow500 = exports.brandYellow400 = exports.brandYellow300 = exports.brandYellow200 = exports.brandYellow100 = exports.brandTan900 = exports.brandTan800 = exports.brandTan700 = exports.brandTan600 = exports.brandTan500 = exports.brandTan400 = exports.brandTan300 = exports.brandTan200 = exports.brandTan100 = exports.brandRed900 = exports.brandRed800 = exports.brandRed700 = exports.brandRed600 = exports.brandRed500 = exports.brandRed400 = exports.brandRed300 = exports.brandRed200 = exports.brandRed100 = exports.brandPurple900 = exports.brandPurple800 = exports.brandPurple700 = exports.brandPurple600 = exports.brandPurple500 = exports.brandPurple400 = exports.brandPurple300 = exports.brandPurple200 = exports.brandPurple100 = exports.brandOrange900 = exports.brandOrange800 = exports.brandOrange700 = exports.brandOrange600 = exports.brandOrange500 = exports.brandOrange400 = exports.brandOrange300 = exports.brandOrange200 = exports.brandOrange100 = exports.brandNavy900 = exports.brandNavy800 = exports.brandNavy700 = exports.brandNavy600 = exports.brandNavy500 = exports.brandNavy400 = exports.brandNavy300 = exports.brandNavy200 = exports.brandNavy100 = exports.brandGreen900 = exports.brandGreen800 = exports.brandGreen700 = exports.brandGreen600 = exports.brandGreen500 = exports.brandGreen400 = exports.brandGreen300 = exports.brandGreen200 = exports.brandGreen100 = exports.brandBrown900 = exports.brandBrown800 = exports.brandBrown700 = exports.brandBrown600 = exports.brandBrown500 = exports.brandBrown400 = exports.brandBrown300 = exports.brandBrown200 = exports.brandBrown100 = exports.borderPrimary = exports.borderNeutral = exports.borderInvalidFocus = exports.borderInvalid = exports.borderIdle = exports.borderFocusWarning = exports.borderFocusSuccess = exports.borderFocusNeutral = exports.borderFocusDanger = exports.borderFocus = exports.borderDisabled = exports.borderDanger = exports.background = void 0;
exports.warningBase = exports.warning900 = exports.warning800 = exports.warning700 = exports.warning600 = exports.warning500 = exports.warning50 = exports.warning400 = exports.warning300 = exports.warning200 = exports.warning100 = exports.successBase = exports.success900 = exports.success800 = exports.success700 = exports.success600 = exports.success500 = exports.success50 = exports.success400 = exports.success300 = exports.success200 = exports.success100 = exports.secondaryBase = exports.secondary900 = exports.secondary800 = exports.secondary700 = exports.secondary600 = exports.secondary500 = exports.secondary400 = exports.secondary300 = exports.secondary200 = exports.secondary100 = exports.ringPrimary = exports.ringNeutral = exports.primaryBase = exports.primary900 = exports.primary800 = exports.primary700 = exports.primary600 = exports.primary500 = exports.primary50 = exports.primary400 = exports.primary300 = exports.primary200 = exports.primary100 = exports.overlayLight = exports.overlayDark = exports.neutralTextLight = exports.neutralText = exports.neutralStroke = exports.neutralSecondaryText = exports.neutralDisabled = exports.neutralCard = exports.neutralBackgroundDark = exports.neutralBackground = exports.neutral900 = exports.neutral850 = exports.neutral800 = exports.neutral750 = exports.neutral700 = exports.neutral600 = exports.neutral550 = exports.neutral500 = exports.neutral50 = exports.neutral400 = exports.neutral300 = exports.neutral200 = exports.neutral100 = exports.neutral0 = exports.lightAlpha900 = exports.lightAlpha800 = exports.lightAlpha700 = exports.lightAlpha600 = exports.lightAlpha500 = exports.lightAlpha50 = exports.lightAlpha400 = exports.lightAlpha300 = exports.lightAlpha200 = exports.lightAlpha100 = exports.haloWarning = exports.haloSuccess = exports.haloPrimary = exports.haloNeutral = exports.haloDanger = exports.foreground = exports.darkAlpha900 = exports.darkAlpha800 = exports.darkAlpha700 = exports.darkAlpha600 = exports.darkAlpha500 = exports.darkAlpha50 = void 0;
const primary50 = "#ecf2ff"; // Primary 50
exports.primary50 = primary50;
const primary100 = "#ecf2ff"; // Primary 100
exports.primary100 = primary100;
const primary200 = "#d3e2ff"; // Primary 200
exports.primary200 = primary200;
const primary300 = "#a0c1ff"; // Primary 300
exports.primary300 = primary300;
const primary400 = "#7eaaff"; // Primary 400
exports.primary400 = primary400;
const primary500 = "#538dff"; // Primary 500
exports.primary500 = primary500;
const primary600 = "#306aff"; // Primary 600
exports.primary600 = primary600;
const primary700 = "#0d42ff"; // Primary 700
exports.primary700 = primary700;
const primary800 = "#0529aa"; // Primary 800
exports.primary800 = primary800;
const primary900 = "#061b66"; // Primary 900
exports.primary900 = primary900;
const primaryBase = "#0d42ff"; // Primary
exports.primaryBase = primaryBase;
const secondary100 = "#f4e4fe"; // Secondary 100
exports.secondary100 = secondary100;
const secondary200 = "#e7c0ff"; // Secondary 200
exports.secondary200 = secondary200;
const secondary300 = "#d6a3ff"; // Secondary 300
exports.secondary300 = secondary300;
const secondary400 = "#bd7bff"; // Secondary 400
exports.secondary400 = secondary400;
const secondary500 = "#a056ff"; // Secondary 500
exports.secondary500 = secondary500;
const secondary600 = "#833bf9"; // Secondary 600
exports.secondary600 = secondary600;
const secondary700 = "#6921de"; // Secondary 700
exports.secondary700 = secondary700;
const secondary800 = "#5619b8"; // Secondary 800
exports.secondary800 = secondary800;
const secondary900 = "#3a1064"; // Secondary 900
exports.secondary900 = secondary900;
const secondaryBase = "#a056ff"; // Secondary
exports.secondaryBase = secondaryBase;
const neutral0 = "#ffffff"; // Neutral 0
exports.neutral0 = neutral0;
const neutral50 = "#fbfbfd"; // Neutral 50
exports.neutral50 = neutral50;
const neutral100 = "#f1f1f4"; // Neutral 100
exports.neutral100 = neutral100;
const neutral200 = "#e2e7ea"; // Neutral 200
exports.neutral200 = neutral200;
const neutral300 = "#cfd6d9"; // Neutral 300
exports.neutral300 = neutral300;
const neutral400 = "#b0b7ba"; // Neutral 400
exports.neutral400 = neutral400;
const neutral500 = "#8f979b"; // Neutral 500
exports.neutral500 = neutral500;
const neutral550 = "#8f979b"; // Neutral 550
exports.neutral550 = neutral550;
const neutral600 = "#62696c"; // Neutral 600
exports.neutral600 = neutral600;
const neutral700 = "#474c4f"; // Neutral 700
exports.neutral700 = neutral700;
const neutral750 = "#36393c"; // Neutral 700
exports.neutral750 = neutral750;
const neutral800 = "#272a2c"; // Neutral 800
exports.neutral800 = neutral800;
const neutral850 = "#1b1b1c"; // Neutral 850
exports.neutral850 = neutral850;
const neutral900 = "#0e0e0e"; // Neutral 900
exports.neutral900 = neutral900;
const neutralBackground = "#ffffff"; // Background
exports.neutralBackground = neutralBackground;
const neutralBackgroundDark = "#f1f1f4"; // Background Dark
exports.neutralBackgroundDark = neutralBackgroundDark;
const neutralDisabled = "#8f979b"; // Disabled
exports.neutralDisabled = neutralDisabled;
const neutralText = "#0e0e0e"; // Text
exports.neutralText = neutralText;
const neutralSecondaryText = "#62696c"; // Secondary Text
exports.neutralSecondaryText = neutralSecondaryText;
const neutralTextLight = "#62696c"; // Text Light
exports.neutralTextLight = neutralTextLight;
const neutralStroke = "#e2e7ea"; // Stroke
exports.neutralStroke = neutralStroke;
const neutralCard = "#f1f1f4"; // Card
exports.neutralCard = neutralCard;
const success50 = "#eaf2eb"; // Success 50
exports.success50 = success50;
const success100 = "#eaf2eb"; // Success 100
exports.success100 = success100;
const success200 = "#c4edc7"; // Success 200
exports.success200 = success200;
const success300 = "#8ae293"; // Success 300
exports.success300 = success300;
const success400 = "#46cb53"; // Success 400
exports.success400 = success400;
const success500 = "#01ad13"; // Success 500
exports.success500 = success500;
const success600 = "#019610"; // Success 600
exports.success600 = success600;
const success700 = "#00740c"; // Success 700
exports.success700 = success700;
const success800 = "#03580b"; // Success 800
exports.success800 = success800;
const success900 = "#103614"; // Success 900
exports.success900 = success900;
const successBase = "#01ad13"; // Success
exports.successBase = successBase;
const warning50 = "#f7f0ee"; // Warning 50
exports.warning50 = warning50;
const warning100 = "#f7f0ee"; // Warning 100
exports.warning100 = warning100;
const warning200 = "#fdecbf"; // Warning 200
exports.warning200 = warning200;
const warning300 = "#ffdd82"; // Warning 300
exports.warning300 = warning300;
const warning400 = "#fdcd50"; // Warning 400
exports.warning400 = warning400;
const warning500 = "#f3ac21"; // Warning 500
exports.warning500 = warning500;
const warning600 = "#d28107"; // Warning 600
exports.warning600 = warning600;
const warning700 = "#ab6513"; // Warning 700
exports.warning700 = warning700;
const warning800 = "#723e01"; // Warning 800
exports.warning800 = warning800;
const warning900 = "#3f2303"; // Warning 900
exports.warning900 = warning900;
const warningBase = "#f3ac21"; // Warning
exports.warningBase = warningBase;
const danger50 = "#f7f0ee"; // Danger 50
exports.danger50 = danger50;
const danger100 = "#f7f0ee"; // Danger 100
exports.danger100 = danger100;
const danger200 = "#fbdcd5"; // Danger 200
exports.danger200 = danger200;
const danger300 = "#ffb4aa"; // Danger 300
exports.danger300 = danger300;
const danger400 = "#ff8e7e"; // Danger 400
exports.danger400 = danger400;
const danger500 = "#f75936"; // Danger 500
exports.danger500 = danger500;
const danger600 = "#e0340e"; // Danger 600
exports.danger600 = danger600;
const danger700 = "#c20b0b"; // Danger 700
exports.danger700 = danger700;
const danger800 = "#890505"; // Danger 800
exports.danger800 = danger800;
const danger900 = "#560202"; // Danger 900
exports.danger900 = danger900;
const dangerBase = "#f75936"; // Danger
exports.dangerBase = dangerBase;
const brandNavy100 = "#e6ecf5"; // [Brand] Navy 100
exports.brandNavy100 = brandNavy100;
const brandNavy200 = "#acc0db"; // [Brand] Navy 200
exports.brandNavy200 = brandNavy200;
const brandNavy300 = "#7395be"; // [Brand] Navy 300
exports.brandNavy300 = brandNavy300;
const brandNavy400 = "#39699f"; // [Brand] Navy 400
exports.brandNavy400 = brandNavy400;
const brandNavy500 = "#003e7d"; // [Brand] Navy 500
exports.brandNavy500 = brandNavy500;
const brandNavy600 = "#00396a"; // [Brand] Navy 600
exports.brandNavy600 = brandNavy600;
const brandNavy700 = "#003257"; // [Brand] Navy 700
exports.brandNavy700 = brandNavy700;
const brandNavy800 = "#002a45"; // [Brand] Navy 800
exports.brandNavy800 = brandNavy800;
const brandNavy900 = "#002032"; // [Brand] Navy 900
exports.brandNavy900 = brandNavy900;
const brandGreen100 = "#eaf2eb"; // [Brand] Green 100
exports.brandGreen100 = brandGreen100;
const brandGreen200 = "#c4edc7"; // [Brand] Green 200
exports.brandGreen200 = brandGreen200;
const brandGreen300 = "#8ae293"; // [Brand] Green 300
exports.brandGreen300 = brandGreen300;
const brandGreen400 = "#46cb53"; // [Brand] Green 400
exports.brandGreen400 = brandGreen400;
const brandGreen500 = "#01ad13"; // [Brand] Green 500
exports.brandGreen500 = brandGreen500;
const brandGreen600 = "#019610"; // [Brand] Green 600
exports.brandGreen600 = brandGreen600;
const brandGreen700 = "#00740c"; // [Brand] Green 700
exports.brandGreen700 = brandGreen700;
const brandGreen800 = "#03580b"; // [Brand] Green 800
exports.brandGreen800 = brandGreen800;
const brandGreen900 = "#103614"; // [Brand] Green 900
exports.brandGreen900 = brandGreen900;
const brandBrown100 = "#ece8e6"; // [Brand] Brown 100
exports.brandBrown100 = brandBrown100;
const brandBrown200 = "#c1b5ac"; // [Brand] Brown 200
exports.brandBrown200 = brandBrown200;
const brandBrown300 = "#948275"; // [Brand] Brown 300
exports.brandBrown300 = brandBrown300;
const brandBrown400 = "#674f3e"; // [Brand] Brown 400
exports.brandBrown400 = brandBrown400;
const brandBrown500 = "#381c08"; // [Brand] Brown 500
exports.brandBrown500 = brandBrown500;
const brandBrown600 = "#301607"; // [Brand] Brown 600
exports.brandBrown600 = brandBrown600;
const brandBrown700 = "#271106"; // [Brand] Brown 700
exports.brandBrown700 = brandBrown700;
const brandBrown800 = "#1f0d05"; // [Brand] Brown 800
exports.brandBrown800 = brandBrown800;
const brandBrown900 = "#160803"; // [Brand] Brown 900
exports.brandBrown900 = brandBrown900;
const brandRed100 = "#f7f0ee"; // [Brand] Red 100
exports.brandRed100 = brandRed100;
const brandRed200 = "#fbdcd5"; // [Brand] Red 200
exports.brandRed200 = brandRed200;
const brandRed300 = "#ffb4aa"; // [Brand] Red 300
exports.brandRed300 = brandRed300;
const brandRed400 = "#ff8e7e"; // [Brand] Red 400
exports.brandRed400 = brandRed400;
const brandRed500 = "#f75936"; // [Brand] Red 500
exports.brandRed500 = brandRed500;
const brandRed600 = "#e0340e"; // [Brand] Red 600
exports.brandRed600 = brandRed600;
const brandRed700 = "#c20b0b"; // [Brand] Red 700
exports.brandRed700 = brandRed700;
const brandRed800 = "#890505"; // [Brand] Red 800
exports.brandRed800 = brandRed800;
const brandRed900 = "#560202"; // [Brand] Red 900
exports.brandRed900 = brandRed900;
const brandTan100 = "#fffcf7"; // [Brand] Tan 100
exports.brandTan100 = brandTan100;
const brandTan200 = "#fdf6e7"; // [Brand] Tan 200
exports.brandTan200 = brandTan200;
const brandTan300 = "#fbefd8"; // [Brand] Tan 300
exports.brandTan300 = brandTan300;
const brandTan400 = "#f7e8ca"; // [Brand] Tan 400
exports.brandTan400 = brandTan400;
const brandTan500 = "#f2e0bd"; // [Brand] Tan 500
exports.brandTan500 = brandTan500;
const brandTan600 = "#cebda1"; // [Brand] Tan 600
exports.brandTan600 = brandTan600;
const brandTan700 = "#a99a84"; // [Brand] Tan 700
exports.brandTan700 = brandTan700;
const brandTan800 = "#857868"; // [Brand] Tan 800
exports.brandTan800 = brandTan800;
const brandTan900 = "#61564c"; // [Brand] Tan 900
exports.brandTan900 = brandTan900;
const brandOrange100 = "#ffeee6"; // [Brand] Orange 100
exports.brandOrange100 = brandOrange100;
const brandOrange200 = "#ffc9ac"; // [Brand] Orange 200
exports.brandOrange200 = brandOrange200;
const brandOrange300 = "#ffa575"; // [Brand] Orange 300
exports.brandOrange300 = brandOrange300;
const brandOrange400 = "#ff8345"; // [Brand] Orange 500
exports.brandOrange400 = brandOrange400;
const brandOrange500 = "#f5631a"; // [Brand] Orange 500
exports.brandOrange500 = brandOrange500;
const brandOrange600 = "#d04d16"; // [Brand] Orange 600
exports.brandOrange600 = brandOrange600;
const brandOrange700 = "#ab3a13"; // [Brand] Orange 700
exports.brandOrange700 = brandOrange700;
const brandOrange800 = "#86290f"; // [Brand] Orange 800
exports.brandOrange800 = brandOrange800;
const brandOrange900 = "#621b0b"; // [Brand] Orange 900
exports.brandOrange900 = brandOrange900;
const brandYellow100 = "#f7f0ee"; // [Brand] Yellow 100
exports.brandYellow100 = brandYellow100;
const brandYellow200 = "#fdecbf"; // [Brand] Yellow 200
exports.brandYellow200 = brandYellow200;
const brandYellow300 = "#ffdd82"; // [Brand] Yellow 300
exports.brandYellow300 = brandYellow300;
const brandYellow400 = "#fdcd50"; // [Brand] Yellow 400
exports.brandYellow400 = brandYellow400;
const brandYellow500 = "#f3ac21"; // [Brand] Yellow 500
exports.brandYellow500 = brandYellow500;
const brandYellow600 = "#d28107"; // [Brand] Yellow 600
exports.brandYellow600 = brandYellow600;
const brandYellow700 = "#ab6513"; // [Brand] Yellow 700
exports.brandYellow700 = brandYellow700;
const brandYellow800 = "#723e01"; // [Brand] Yellow 800
exports.brandYellow800 = brandYellow800;
const brandYellow900 = "#3f2303"; // [Brand] Yellow 900
exports.brandYellow900 = brandYellow900;
const brandPurple100 = "#f4e4fe"; // [Brand] Purple 100
exports.brandPurple100 = brandPurple100;
const brandPurple200 = "#e7c0ff"; // [Brand] Purple 200
exports.brandPurple200 = brandPurple200;
const brandPurple300 = "#d6a3ff"; // [Brand] Purple 300
exports.brandPurple300 = brandPurple300;
const brandPurple400 = "#bd7bff"; // [Brand] Purple 400
exports.brandPurple400 = brandPurple400;
const brandPurple500 = "#a056ff"; // [Brand] Purple 500
exports.brandPurple500 = brandPurple500;
const brandPurple600 = "#833bf9"; // [Brand] Purple 600
exports.brandPurple600 = brandPurple600;
const brandPurple700 = "#6921de"; // [Brand] Purple 700
exports.brandPurple700 = brandPurple700;
const brandPurple800 = "#5619b8"; // [Brand] Purple 800
exports.brandPurple800 = brandPurple800;
const brandPurple900 = "#3a1064"; // [Brand] Purple 900
exports.brandPurple900 = brandPurple900;
const lightAlpha50 = "rgba(255, 255, 255, 0.04)"; // Translucent Neutral Light 50
exports.lightAlpha50 = lightAlpha50;
const lightAlpha100 = "rgba(255, 255, 255, 0.06)"; // Translucent Neutral Light 100
exports.lightAlpha100 = lightAlpha100;
const lightAlpha200 = "rgba(255, 255, 255, 0.08)"; // Translucent Neutral Light 200
exports.lightAlpha200 = lightAlpha200;
const lightAlpha300 = "rgba(255, 255, 255, 0.16)"; // Translucent Neutral Light 300
exports.lightAlpha300 = lightAlpha300;
const lightAlpha400 = "rgba(255, 255, 255, 0.24)"; // Translucent Neutral Light 400
exports.lightAlpha400 = lightAlpha400;
const lightAlpha500 = "rgba(255, 255, 255, 0.36)"; // Translucent Neutral Light 500
exports.lightAlpha500 = lightAlpha500;
const lightAlpha600 = "rgba(255, 255, 255, 0.48)"; // Translucent Neutral Light 600
exports.lightAlpha600 = lightAlpha600;
const lightAlpha700 = "rgba(255, 255, 255, 0.64)"; // Translucent Neutral Light 700
exports.lightAlpha700 = lightAlpha700;
const lightAlpha800 = "rgba(255, 255, 255, 0.8)"; // Translucent Neutral Light 800
exports.lightAlpha800 = lightAlpha800;
const lightAlpha900 = "rgba(255, 255, 255, 0.92)"; // Translucent Neutral Light 900
exports.lightAlpha900 = lightAlpha900;
const darkAlpha50 = "rgba(0, 0, 0, 0.04)"; // Translucent Neutral Dark 50
exports.darkAlpha50 = darkAlpha50;
const darkAlpha100 = "rgba(0, 0, 0, 0.06)"; // Translucent Neutral Dark 100
exports.darkAlpha100 = darkAlpha100;
const darkAlpha200 = "rgba(0, 0, 0, 0.08)"; // Translucent Neutral Dark 200
exports.darkAlpha200 = darkAlpha200;
const darkAlpha300 = "rgba(0, 0, 0, 0.16)"; // Translucent Neutral Dark 300
exports.darkAlpha300 = darkAlpha300;
const darkAlpha400 = "rgba(0, 0, 0, 0.24)"; // Translucent Neutral Dark 400
exports.darkAlpha400 = darkAlpha400;
const darkAlpha500 = "rgba(0, 0, 0, 0.36)"; // Translucent Neutral Dark 500
exports.darkAlpha500 = darkAlpha500;
const darkAlpha600 = "rgba(0, 0, 0, 0.48)"; // Translucent Neutral Dark 600
exports.darkAlpha600 = darkAlpha600;
const darkAlpha700 = "rgba(0, 0, 0, 0.64)"; // Translucent Neutral Dark 700
exports.darkAlpha700 = darkAlpha700;
const darkAlpha800 = "rgba(0, 0, 0, 0.8)"; // Translucent Neutral Dark 800
exports.darkAlpha800 = darkAlpha800;
const darkAlpha900 = "rgba(0, 0, 0, 0.92)"; // Translucent Neutral Dark 900
exports.darkAlpha900 = darkAlpha900;
const overlayLight = "rgba(255, 255, 255, 0.48)"; // Translucent Overlay Light
exports.overlayLight = overlayLight;
const overlayDark = "rgba(0, 0, 0, 0.48)"; // Translucent Overlay Light
exports.overlayDark = overlayDark;
const background = "#ffffff"; // Background
exports.background = background;
const foreground = "#0e0e0e"; // Foreground
exports.foreground = foreground;
const haloPrimary = "rgba(48,106,255,0.3)"; // Halo Primary
exports.haloPrimary = haloPrimary;
const haloNeutral = "rgba(98,105,108,0.3)"; // Halo Neutral
exports.haloNeutral = haloNeutral;
const haloDanger = "rgba(247,89,54,0.3)"; // Halo Danger
exports.haloDanger = haloDanger;
const haloWarning = "rgba(243,172,33,0.3)"; // Halo Warning
exports.haloWarning = haloWarning;
const haloSuccess = "rgba(1,173,19,0.3)"; // Halo Success
exports.haloSuccess = haloSuccess;
const ringPrimary = "rgba(48,106,255,0.3)"; // Ring Primary
exports.ringPrimary = ringPrimary;
const ringNeutral = "rgba(98,105,108,0.2)"; // Ring Neutral
exports.ringNeutral = ringNeutral;
const borderDanger = "#f75936";
exports.borderDanger = borderDanger;
const borderDisabled = "#cfd6d9";
exports.borderDisabled = borderDisabled;
const borderFocus = "#0d42ff";
exports.borderFocus = borderFocus;
const borderFocusDanger = "#e0340e";
exports.borderFocusDanger = borderFocusDanger;
const borderFocusNeutral = "#474c4f";
exports.borderFocusNeutral = borderFocusNeutral;
const borderFocusSuccess = "#019610";
exports.borderFocusSuccess = borderFocusSuccess;
const borderFocusWarning = "#d28107";
exports.borderFocusWarning = borderFocusWarning;
const borderIdle = "#62696c";
exports.borderIdle = borderIdle;
const borderInvalid = "#f75936";
exports.borderInvalid = borderInvalid;
const borderInvalidFocus = "#e0340e";
exports.borderInvalidFocus = borderInvalidFocus;
const borderNeutral = "#62696c";
exports.borderNeutral = borderNeutral;
const borderPrimary = "#0d42ff";
exports.borderPrimary = borderPrimary;